import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import i18n from '@/utils/i18n.ts';

dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(utc);

// 将指定格式的日期时间字符串转换为另一种格式
export function formatDateTime(dateTimeString) {
  return dayjs.utc(dateTimeString).local().format('YYYY/MM/DD HH:mm:ss');
}

// 将UTC时间转换为当前时区时间并格式化显示
export function formatToLocalTime(utcTime) {
  return dayjs.utc(utcTime).local().format('MMM D,YYYY');
}

// 将毫秒转换为 "MM:SS" 格式
export function formatMilliseconds(milliseconds) {
  const duration = dayjs.duration(milliseconds);
  const minutes = duration.asMinutes();
  const formattedMinutes =
    minutes >= 100
      ? Math.floor(minutes).toString()
      : Math.floor(minutes).toString().padStart(2, '0');
  const seconds = duration.seconds().toString().padStart(2, '0');
  return `${formattedMinutes}:${seconds}`;
}

// 计算会员剩余几天过期
export function computeDay(inputTime) {
  const target = dayjs(inputTime);
  const utcnow = new Date().toUTCString();
  const now = dayjs.tz(utcnow);
  const diffInDays = target.diff(now, 'day', true);
  let day = Math.ceil(diffInDays);

  if (day >= 7) {
    day = 7;
  }
  return day;
}
// // 数字转大写
// function numberToWords(num) {
//   const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
//   const teens = [
//     'ten',
//     'eleven',
//     'twelve',
//     'thirteen',
//     'fourteen',
//     'fifteen',
//     'sixteen',
//     'seventeen',
//     'eighteen',
//     'nineteen',
//   ];
//   const tens = [
//     '',
//     '',
//     'twenty',
//     'thirty',
//     'forty',
//     'fifty',
//     'sixty',
//     'seventy',
//     'eighty',
//     'ninety',
//   ];
//   if (num < 0) return 'minus ' + numberToWords(-num);
//   if (num < 10) return units[num];
//   if (num < 20) return teens[num - 10];
//   if (num < 100) {
//     return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? '-' + units[num % 10] : '');
//   }
//   return num.toString(); // 大于等于100时，返回数字字符串
// }

// 根据传入时间判断是否过期,过期返回false
export function compareTime(inputTime) {
  if (inputTime === null) {
    return false;
  }
  const utcnow = new Date().toUTCString();
  const currentTime = dayjs.tz(utcnow);

  const targetTime = dayjs(inputTime, 'YYYY-MM-DDTHH:mm:ss');
  return currentTime.isBefore(targetTime);
}

// 计算项目时间差
export function timeDiffFromNow(gmt8TimeStr) {
  const given = dayjs.tz(gmt8TimeStr);
  const utcnow = new Date().toUTCString();
  const now = dayjs.tz(utcnow);
  const diff = dayjs.duration(now.diff(given));

  if (diff.years() > 0) {
    return `${i18n.t('As_Home_ProjectTime3', { time: diff.years() })}`;
  } else if (diff.months() > 0) {
    return `${i18n.t('As_Home_ProjectTime4', { time: diff.months() })}`;
  } else if (diff.days() > 0) {
    return `${i18n.t('As_Home_ProjectTime5', { time: diff.days() })}`;
  } else if (diff.hours() > 0) {
    return `${i18n.t('As_Home_ProjectTime6', { time: diff.hours() })}`;
  } else if (diff.minutes() > 0) {
    return `${i18n.t('As_Home_ProjectTime7', { time: diff.minutes() })}`;
  } else {
    return '1 minutes ago';
  }
}

export function formatFromMinuteToSecond(milliseconds) {
  return dayjs.duration(milliseconds).format('mm:ss');
}

export function formatFromMinuteToMs(milliseconds) {
  return dayjs.duration(milliseconds).format('mm:ss.SSS').slice(0, -1);
}

export function formatFromHourToSecond(milliseconds) {
  return dayjs.duration(milliseconds).format('HH:mm:ss');
}

export function formatFromHourToMs(milliseconds) {
  return dayjs.duration(milliseconds).format('HH:mm:ss.SSS').slice(0, -1);
}
